import { TStore } from "@omni/components/redux/store.types";
import { Config } from "@omni/components/utils/config.utils";
import {
    ErrorBoundary,
    ErrorBoundaryFallbackComponent
} from "@omni/components/utils/errorBoundary";
import React, { ComponentType, Fragment, LazyExoticComponent } from "react";
import { Provider } from "react-redux";

const GraniteProvider = React.lazy(() =>
    import(
        "@omni/components/redux/modules/value/translations/translations.provider"
    ).then((module) => ({ default: module.GraniteProvider }))
);

const FeatureToggleProvider = React.lazy(() =>
    import("@omni/components/context/featureToggles.context").then(
        (module) => ({
            default: module.FeatureToggleContextProvider
        })
    )
);

type Props = {
    data: DOMStringMap;
    innerHTML: string;
    store: TStore;
    Component: LazyExoticComponent<ComponentType<any>>;
};

const Entry = ({ data, innerHTML, store, Component }: Props) => {
    if (!Component) {
        console.log("hubo:render - component not found", data?.cqDataPath);
        return <Fragment />;
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallbackComponent}>
            <React.Suspense>
                <Provider store={store}>
                    <GraniteProvider>
                        <FeatureToggleProvider
                            serverSideFeatureToggles={Config["feature-toggles"]}
                        >
                            {React.createElement(Component, {
                                innerHTML,
                                ...data
                            })}
                        </FeatureToggleProvider>
                    </GraniteProvider>
                </Provider>
            </React.Suspense>
        </ErrorBoundary>
    );
};

export default Entry;
